function lazyloadEnabled(placement) {
    const { lazyload = {} } = placement;
    return (lazyload &&
        !("disable" in lazyload && lazyload.disable === false) &&
        typeof lazyload.offset !== "undefined");
}
// eslint-disable-next-line import/prefer-default-export
export { lazyloadEnabled };
//# sourceMappingURL=helpers.js.map